// Must place everything in the correct order
// https://chakra-ui.com/docs/styling/responsive-design#array-syntax
export const BREAKPOINTS = {
  mobile: "0em", // Convenient alias for base
  base: "0em",
  sm: "30em",
  tablet: "48em", // Convenient alias for md
  md: "48em",
  desktop: "62em", // Convenient alias for lg
  lg: "62em",
  xl: "80em",
  "2xl": "96em",
}
